import React from 'react';
import { Box, Typography, Checkbox, FormControlLabel, Stack, Button, RadioGroup, Radio } from '@mui/material';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SmallFormDateField } from '../../../components/small-fields/SmallFormDateField';
import { formatDate } from '../../../services/functions';
import { useEmployees } from './EmployessContext';

const SEASON_YEARS = [2022, 2023, 2024, 2025, 2026, 2027];

export const EmployeesFilter = props => {
  const { setFiltersParams, choices } = useEmployees();

  const [filters, setFilters] = React.useState({
    state: [],
    birth_date_from: null,
    birth_date_to: null,
    season_year: SEASON_YEARS,
    // Filtry Aplikacje
    app_state: [],
    function_type: [],
    additional_qualifications: [],
    range_of_skills: [],
    periods_type: [],
    periods: [],
    ol_periods: [],
    zs_periods: [],
    is_bonus: false,
    resort: 'all',
    resort_declared: 'all',
    date_from: null,
    date_to: null,
    has_sun_active_points: false
  });

  const resetFilters = () => {
    setFilters({
      state: [],
      birth_date_from: null,
      birth_date_to: null,
      season_year: SEASON_YEARS,
      app_state: [],
      function_type: [],
      additional_qualifications: [],
      range_of_skills: [],
      periods_type: [],
      periods: [],
      ol_periods: [],
      zs_periods: [],
      is_bonus: false,
      resort: 'all',
      resort_declared: 'all',
      date_from: null,
      date_to: null,
      has_sun_active_points: false
    });
  };

  console.log(choices);

  React.useEffect(() => {
    const params = new URLSearchParams();

    for (const property in filters) {
      if (filters.hasOwnProperty(property) && filters[property] !== null && filters[property] !== '') {
        if (Array.isArray(filters[property])) {
          filters[property].forEach(value => params.append(property, value));
        } else {
          params.append(property, filters[property]);
        }
      }
    }


    setFiltersParams(params.toString());

  }, [filters]);


  const handleChangeState = value => {
    if (filters.state.includes(value)) {
      setFilters(prev => ({ ...prev, state: prev.state.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, state: [...prev.state, value] }));
    }
  };

  const handleChangeAppState = value => {
    if (filters.app_state.includes(value)) {
      setFilters(prev => ({ ...prev, app_state: prev.app_state.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, app_state: [...prev.app_state, value] }));
    }
  };

  const handleChangeAppStateALL = e => {
    if (e.target.checked) {
      setFilters({ ...filters, app_state: ['NEW', 'ARR', 'AGS', 'REJ', 'RGN', 'FOU', 'ALL', 'SAG', 'AOS'] });
    } else {
      setFilters({ ...filters, app_state: [] });
    }
  };

  const handleChangeFunction = value => {
    if (filters.function_type.includes(value)) {
      setFilters(prev => ({ ...prev, function_type: prev.function_type.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, function_type: [...prev.function_type, value] }));
    }
  };

  const handleChangeFunctionALL = e => {
    if (e.target.checked) {
      setFilters({ ...filters, function_type: choices.function_type?.map(item => item.value) });
    } else {
      setFilters({ ...filters, function_type: [] });
    }
  };

  const handleChangeArray = (value, name) => {
    if (filters[name].includes(value)) {
      setFilters(prev => ({ ...prev, [name]: prev[name].filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, [name]: [...prev[name], value] }));
    }
  };

  const handleChangeArrayALL = (e, name) => {
    if (e.target.checked) {
      setFilters({ ...filters, [name]: choices[name]?.map(item => item.value) });
    } else {
      setFilters({ ...filters, [name]: [] });
    }
  };

  const handleChangePeriods = value => {
    if (filters.periods.includes(value)) {
      setFilters(prev => ({ ...prev, periods: prev.periods.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, periods: [...prev.periods, value] }));
    }
  };

  const handleChangePeriodsOL = value => {
    if (filters.ol_periods.includes(value)) {
      setFilters(prev => ({ ...prev, ol_periods: prev.ol_periods.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, ol_periods: [...prev.ol_periods, value] }));
    }
  };

  const handleChangePeriodsZS = value => {
    if (filters.zs_periods.includes(value)) {
      setFilters(prev => ({ ...prev, zs_periods: prev.zs_periods.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, zs_periods: [...prev.zs_periods, value] }));
    }
  };


  const handleChangeStateALL = e => {
    if (e.target.checked) {
      setFilters({ ...filters, state: ['FOU', 'HIR'] });
    } else {
      setFilters({ ...filters, state: [] });
    }
  };

  const handleChangeSeason = value => {
    if (filters.season_year.includes(value)) {
      setFilters(prev => ({
        ...prev,
        season_year: prev.season_year.filter(v => v !== value)
      }));
    } else {
      setFilters(prev => ({
        ...prev,
        season_year: [...prev.season_year, value]
      }));
    }
  };

  const handleChangeSeasonALL = e => {
    if (e.target.checked) {
      setFilters(prev => ({ ...prev, season_year: SEASON_YEARS }));
    } else {
      setFilters(prev => ({ ...prev, season_year: [] }));
    }
  };


  return <Box sx = {{ width: '95%' }}>
    <Stack direction="row" justifyContent="space-between" alignItems="baseline">
      <Typography variant="h6" sx={{ mb: 2 }}>Filtry</Typography>
      <Button onClick={resetFilters}>Resetuj</Button>
    </Stack>
    <TreeView
      defaultExpanded={['3']}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      defaultEndIcon={null}
    >
      <TreeItem nodeId="1" label={ <FormControlLabel
        label="Status"
        control={
          <Checkbox
            onChange={handleChangeStateALL}
            onClick={e => e.stopPropagation()}
            checked={filters.state.length === 2}
            indeterminate={filters.state.length < 2 && filters.state.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          <FormControlLabel
            label="FINAL OUT"
            control={<Checkbox
              checked={filters.state.includes('FOU')}
              onChange={() => handleChangeState('FOU')}
              sx={
                {
                  color: '#960018',
                  '&.Mui-checked': {
                    color: '#960018'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Zatrudniony"
            control={<Checkbox
              checked={filters.state.includes('HIR')}
              onChange={() => handleChangeState('HIR')}
              sx={
                {
                  color: '#4CBB17',
                  '&.Mui-checked': {
                    color: '#4CBB17'
                  }
                }
              }/>}
          />
        </Stack>
      </TreeItem>
      <TreeItem
        nodeId="2"
        label={
          <FormControlLabel
            label="Sezon"
            control={
              <Checkbox
                onChange={handleChangeSeasonALL}
                onClick={e => e.stopPropagation()}
                checked={filters.season_year.length === SEASON_YEARS.length}
                indeterminate={
                  filters.season_year.length > 0 &&
            filters.season_year.length < SEASON_YEARS.length
                }
              />
            }
          />
        }
      >
        <Stack sx={{ pl: '18px' }}>
          {SEASON_YEARS.map(year => (
            <FormControlLabel
              key={year}
              label={year}
              control={
                <Checkbox
                  checked={filters.season_year.includes(year)}
                  onChange={() => handleChangeSeason(year)}
                />
              }
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="3" label={<Typography style={{ padding: 8 }}>Data urodzenia</Typography>}>
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="birth_date_from"
          type="text"
          label="Data urodzenia od"
          variant="standard"
          value={filters.birth_date_from}
          onChange={val => setFilters({ ...filters, birth_date_from: formatDate(val) })}
        />
        <SmallFormDateField
          sx = {{ width: '100%', mb: 2 }}
          name="birth_date_to"
          type="text"
          label="Data urodzenia do"
          variant="standard"
          value={filters.birth_date_to}
          onChange={val => setFilters({ ...filters, birth_date_to: formatDate(val) })}
        />
      </TreeItem>
      <TreeItem nodeId="4" label={ <FormControlLabel
        label="Status Aplikacje"
        control={
          <Checkbox
            onChange={handleChangeAppStateALL}
            onClick={e => e.stopPropagation()}
            checked={filters.app_state.length === 9}
            indeterminate={filters.app_state.length < 9 && filters.app_state.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          <FormControlLabel
            label="Nowy"
            control={<Checkbox
              checked={filters.app_state.includes('NEW')}
              onChange={() => handleChangeAppState('NEW')}
              sx={
                {
                  color: '#0CAFFF',
                  '&.Mui-checked': {
                    color: '#0CAFFF'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Ustalenia"
            control={<Checkbox
              checked={filters.app_state.includes('ARR')}
              onChange={() => handleChangeAppState('ARR')}
              sx={
                {
                  color: '#FFC107',
                  '&.Mui-checked': {
                    color: '#FFC107'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Wysłana umowa"
            control={<Checkbox
              checked={filters.app_state.includes('AGS')}
              onChange={() => handleChangeAppState('AGS')}
              sx={
                {
                  color: '#004320',
                  '&.Mui-checked': {
                    color: '#004320'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Wysłać umowe"
            control={<Checkbox
              checked={filters.app_state.includes('SAG')}
              onChange={() => handleChangeAppState('SAG')}
              sx={
                {
                  color: '#ff5f1f',
                  '&.Mui-checked': {
                    color: '#ff5f1f'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Umowa poza systemem"
            control={<Checkbox
              checked={filters.app_state.includes('AOS')}
              onChange={() => handleChangeAppState('AOS')}
              sx={
                {
                  color: '#74dd21',
                  '&.Mui-checked': {
                    color: '#74dd21'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Rezygnacja"
            control={<Checkbox
              checked={filters.app_state.includes('RGN')}
              onChange={() => handleChangeAppState('RGN')}
              sx={
                {
                  color: 'gray',
                  '&.Mui-checked': {
                    color: 'gray'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Odrzucony"
            control={<Checkbox
              checked={filters.app_state.includes('REJ')}
              onChange={() => handleChangeAppState('REJ')}
              sx={
                {
                  color: '#FF00BF',
                  '&.Mui-checked': {
                    color: '#FF00BF'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="FINAL OUT"
            control={<Checkbox
              checked={filters.app_state.includes('FOU')}
              onChange={() => handleChangeAppState('FOU')}
              sx={
                {
                  color: '#960018',
                  '&.Mui-checked': {
                    color: '#960018'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="ALL"
            control={<Checkbox
              checked={filters.app_state.includes('ALL')}
              onChange={() => handleChangeAppState('ALL')}
              sx={
                {
                  color: '#662d91',
                  '&.Mui-checked': {
                    color: '#662d91'
                  }
                }
              }/>}
          />
        </Stack>
      </TreeItem>
      <TreeItem nodeId="5" label={ <FormControlLabel
        label="Funkcja"
        control={
          <Checkbox
            onChange={handleChangeFunctionALL}
            onClick={e => e.stopPropagation()}
            checked={filters.function_type.length === choices.function_type?.length}
            indeterminate={filters.function_type.length < choices.function_type?.length && filters.function_type.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {/* {choices.function_type?.map(item => item.label === 'pracownik gastronomiczny' || item.label === 'pracownik socjalny' ? null : ( */}
          {choices.function_type?.map(item => item.label === 'pracownik socjalny' ? null : (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.function_type.includes(item.value)}
                onChange={() => handleChangeFunction(item.value)}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="6" label={ <FormControlLabel
        label="Uprawnienia"
        control={
          <Checkbox
            onChange={e => handleChangeArrayALL(e, 'additional_qualifications')}
            onClick={e => e.stopPropagation()}
            checked={filters.additional_qualifications.length === choices.additional_qualifications?.length}
            indeterminate={filters.additional_qualifications.length < choices.additional_qualifications?.length && filters.additional_qualifications.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {choices.additional_qualifications?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.additional_qualifications.includes(item.value)}
                onChange={() => handleChangeArray(item.value, 'additional_qualifications')}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="7" label={ <FormControlLabel
        label="Zakres umiejętności"
        control={
          <Checkbox
            onChange={e => handleChangeArrayALL(e, 'range_of_skills')}
            onClick={e => e.stopPropagation()}
            checked={filters.range_of_skills.length === choices.range_of_skills?.length}
            indeterminate={filters.range_of_skills.length < choices.range_of_skills?.length && filters.range_of_skills.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {choices.range_of_skills?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.range_of_skills.includes(item.value)}
                onChange={() => handleChangeArray(item.value, 'range_of_skills')}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="8" label={ <FormControlLabel
        label="Impreza"
        control={
          <Checkbox
            onChange={e => handleChangeArrayALL(e, 'periods_type')}
            onClick={e => e.stopPropagation()}
            checked={filters.periods_type.length === choices.periods_type?.length}
            indeterminate={filters.periods_type.length < choices.periods_type?.length && filters.periods_type.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {choices.periods_type?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.periods_type.includes(item.value)}
                onChange={() => handleChangeArray(item.value, 'periods_type')}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="9" label={ <FormControlLabel
        label="Bonus"
        control={
          <Checkbox
            onChange={e => setFilters(prev => ({ ...prev, is_bonus: e.target.checked }))}
            checked={filters.is_bonus}
          />
        }
      /> }>
      </TreeItem>
      <TreeItem nodeId="10" label={<Typography style={{ padding: 8 }}>Ośrodek - zatrudnienie</Typography>}>
        <RadioGroup
          value={filters.resort}
          onChange={event => setFilters(prev => ({ ...prev, resort: event.target.value }))}
          sx={{ pl: '18px' }}
        >
          <FormControlLabel value="all" control={<Radio />} label="Wszystkie" />
          <FormControlLabel value="giewartow" control={<Radio />} label="GIEWARTÓW" />
          <FormControlLabel value="mrowki" control={<Radio />} label="MRÓWKI" />
        </RadioGroup>
      </TreeItem>
      <TreeItem nodeId="11" label={<Typography style={{ padding: 8 }}>Ośrodek - deklarowany termin</Typography>}>
        <RadioGroup
          value={filters.resort_declared}
          onChange={event => setFilters(prev => ({ ...prev, resort_declared: event.target.value }))}
          sx={{ pl: '18px' }}
        >
          <FormControlLabel value="all" control={<Radio />} label="Wszystkie" />
          <FormControlLabel value="giewartow" control={<Radio />} label="GIEWARTÓW" />
          <FormControlLabel value="mrowki" control={<Radio />} label="MRÓWKI" />
        </RadioGroup>
      </TreeItem>
      <TreeItem nodeId="12" label={<Typography style={{ padding: 8 }}>Termin zadeklarowany</Typography>}>
        <Stack sx={{ pl: '18px' }}>
          {Object.keys(choices.ol_periods_grouped ?? {})?.map(key => <TreeItem key={key} nodeId={key} label={<Typography style={{ padding: 8 }}>{key}</Typography>}>
            {choices.ol_periods_grouped[key]?.map(item => (
              <FormControlLabel
                key={item.value}
                label={item.label}
                sx={{ mt: '10px' }}
                control={<Checkbox
                  checked={filters.periods.includes(item.value)}
                  onChange={() => handleChangePeriods(item.value)}
                />}
              />
            ))}
          </TreeItem>)}
          {choices.zs_periods?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              sx={{ mt: '10px' }}
              control={<Checkbox
                checked={filters.periods.includes(item.value)}
                onChange={() => handleChangePeriods(item.value)}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="13" label={<Typography style={{ padding: 8 }}>Termin zatrudniony w obozach</Typography>}>
        <Stack sx={{ pl: '18px' }}>
          {Object.keys(choices.ol_periods_grouped ?? {})?.map((key, idx) => <TreeItem key={key} nodeId={idx + 100} label={<Typography style={{ padding: 8 }}>{key}</Typography>}>
            {choices.ol_periods_grouped[key]?.map(item => (
              <FormControlLabel
                key={item.value}
                label={item.label}
                sx={{ mt: '10px' }}
                control={<Checkbox
                  checked={filters.ol_periods.includes(item.value)}
                  onChange={() => handleChangePeriodsOL(item.value)}
                />}
              />
            ))}
          </TreeItem>)}
        </ Stack>
      </TreeItem>
      <TreeItem nodeId="14" label={<Typography style={{ padding: 8 }}>Termin zatrudniony w zielonych szkołach</Typography>}>
        <Stack sx={{ pl: '18px' }}>
          {choices.zs_periods?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              sx={{ mt: '10px' }}
              control={<Checkbox
                checked={filters.zs_periods.includes(item.value)}
                onChange={() => handleChangePeriodsZS(item.value)}
              />}
            />
          ))}
        </ Stack>
      </TreeItem>
      <TreeItem nodeId="15" label={<Typography style={{ padding: 8 }}>Termin umowy</Typography>}>
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="date_from"
          type="text"
          label="Termin od"
          variant="standard"
          value={filters.date_from}
          onChange={val => setFilters({ ...filters, date_from: formatDate(val) })}
        />
        <SmallFormDateField
          sx = {{ width: '100%', mb: 2 }}
          name="date_to"
          type="text"
          label="Termin do"
          variant="standard"
          value={filters.date_to}
          onChange={val => setFilters({ ...filters, date_to: formatDate(val) })}
        />
      </TreeItem>
      <TreeItem nodeId="16" label={ <FormControlLabel
        label="Przyznano punkty Sun Active"
        control={
          <Checkbox
            onChange={e => setFilters(prev => ({ ...prev, has_sun_active_points: e.target.checked }))}
            checked={filters.has_sun_active_points}
          />
        }
      /> }></TreeItem>
    </TreeView>

  </Box>;

};

export default EmployeesFilter;
